import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import Link from 'next/link';
import React from 'react';

type AddLeasingRightButtonProps = {
	accountId?: string | number;
	disabled?: boolean;
};

export const AddLeasingRightButton = ({ accountId, disabled }: AddLeasingRightButtonProps) => (
	<Link href={`/lease${accountId ? `/?accountId=${accountId}` : ''}`} target='_blank'>
		<Button
			size='small'
			variant='outlined'
			disabled={disabled}
			startIcon={<AddIcon />}
			data-cy='add-leasing-right-button'
		>
			Add New Leasing Right
		</Button>
	</Link>
);
